import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import DynamicSiteForm from '../components/forms/DynamicSiteForm';
import forms from '../cms/forms.json';
import '../css/pages/StandaloneForm.css';

/**
 * Full-page CMS form at /forms/:formKey (e.g. /forms/volunteer-signup).
 */
const StandaloneFormPage = () => {
  const { formKey } = useParams();
  const formDef = forms[formKey];

  if (!formDef || !formDef.enabled) {
    return <Navigate to="/not-found" replace />;
  }

  return (
    <>
      <PageHeader title={formDef.title} subtitle={formDef.subtitle} />
      <div className="standalone-form-container">
        <DynamicSiteForm formKey={formKey} onClose={null} maxWidth="720px" inline />
      </div>
    </>
  );
};

export default StandaloneFormPage;
